import TransactionsTable from 'modules/expenses/components/TransactionsTable'

export default function TransactionsPage() {
  return (
      <TransactionsTable/>
  )
}